module.exports = __webpack_public_path__ + "static/media/icon-pinterest.ff1eedbc.svg";